import { useQuery } from '@tanstack/react-query'

import { fetchBrandsSearch } from 'api/fetchers/fetchBrands'

export const useBrandRecommendations = (searchTerm: string) => {
  return useQuery({
    queryKey: ['brandRecommendations', searchTerm],

    queryFn: ({ signal }) => fetchBrandsSearch({ searchTerm, limit: 3 }, signal),

    enabled: searchTerm.length >= 3,

    staleTime: 5 * 60 * 1000, // cache for 5 min

    select: (data: any) => data?.data ?? [],
  })
}
